import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~backoffice/app/~shared/abstract-components/base.component';
import { Organization } from '~core/models/organization.models';

@Component({
  selector: 'company-verification-success',
  standalone: false,
  templateUrl: './company-verification-success.component.html',
  styleUrl: './company-verification-success.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyVerificationSuccessComponent extends BaseComponent {
  company = input<Organization>();
}
